import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=2b70a53c&scoped=true"
import script from "./InfoDialog.vue?vue&type=script&lang=js"
export * from "./InfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70a53c",
  null
  
)

export default component.exports